import React, { useState, useRef } from 'react';
import { useInterval } from '@fuxi/eevee-hooks';
import classnames from 'classnames/bind';
import styles from './index.module.less';

const cx = classnames.bind(styles);

interface ListItem {
  img: string;
  video?: string;
  title?: string;
}

interface Props {
  dataList: ListItem[];
  imgWidth?: number;
  imgHeight?: number;
  activeWidth?: number;
}

export const TranslateBanner = ({ imgWidth = 259, imgHeight = 440, activeWidth = 782, dataList }: Props) => {
  const [activeIndex, setActiveIndex] = useState(Math.floor(dataList.length / 2));
  const [timer, setTimer] = useState<number | undefined>(2500);
  const listVideRefs = useRef<(HTMLVideoElement | null)[]>([]);

  useInterval(() => {
    setActiveIndex(activeIndex + 1 >= dataList.length ? 0 : activeIndex + 1);
  }, timer);

  return (
    <div
      className={cx('banner-wrapper')}
      onMouseEnter={() => {
        setTimer(undefined);
      }}
      onMouseLeave={() => {
        setTimer(2500);
      }}>
      {dataList.map((item, index) => {
        return (
          <div
            key={`banner-item-${index}`}
            onClick={() => {
              setActiveIndex(index);
            }}
            className={cx('banner-item', { active: activeIndex === index })}
            style={{
              backgroundImage: `url('${item.img}')`,
              width: `${activeIndex === index ? activeWidth : imgWidth}px`,
              height: `${imgHeight}px`,
            }}>
            {item.video && (
              <video ref={el => (listVideRefs.current[index] = el)} preload="auto" loop muted autoPlay>
                <source src={item.video} />
              </video>
            )}
            <div className={cx('banner-item-modal')}></div>
            {item.title && <span className={cx('banner-title')}>{item.title}</span>}
            <span className={cx('banner-active-line')}></span>
          </div>
        );
      })}
    </div>
  );
};

export default TranslateBanner;
